import { render } from "./ethical-sustainability.vue?vue&type=template&id=4c30d279&scoped=true"
import script from "./ethical-sustainability.vue?vue&type=script&lang=js"
export * from "./ethical-sustainability.vue?vue&type=script&lang=js"

import "./ethical-sustainability.vue?vue&type=style&index=0&id=4c30d279&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c30d279"]])

export default __exports__